import React from 'react';
import ModuleTopic from '../../components/ModuleTopic';

interface ITopicProps {
  settings: any;
}

const TopicSe: React.FunctionComponent<ITopicProps> = ({ settings }) => (
  <ModuleTopic settings={settings} moduleKey="se" />
);

export default TopicSe;
